import { jsx as _jsx } from "react/jsx-runtime";
import Logo from "@/assets/Beep_White.png";
export default function Loader() {
    return (_jsx("div", { className: "bg-[#0064A7] h-screen w-screen flex items-center justify-center", children: _jsx("img", { src: Logo, alt: "BeepPlus", className: "w-32" }) }));
}
